import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { authKeys, RequestTypes } from '@core/react-query/features/auth'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { ICreateMFASession } from '@core/entities/auth'

export const useCreateMfaSession = (
  options?: UseMutationOptions<
    ICreateMFASession,
    RequestErrorType,
    RequestTypes['createMFASession']
  >,
) => {
  return useMutation({
    ...authKeys.createMFASession,
    ...options,
  })
}
